import { Fragment } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// react-router components
import { Link } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";

// Soft UI Dashboard PRO React example components
import BaseNavbarCategory from "./BaseNavbarCategory";
import BaseNavbarMenu from "./BaseNavbarMenu";
import { Icon } from "@mui/material";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { useSoftUIController } from "hooks/context";

function MenuOptions({ routes, route_path, open = false, close = false, openHandler = false, mobileMenu = false, noCollapse = false }) {
    const [controller] = useSoftUIController();
    const { userPermissions = [] } = controller; // Extracted userPermissions context

    const renderMenuOptionsRoute = (routeName) => {
        if (!noCollapse) {
            return routes.map(({ key, collapse }) => (
                <Fragment key={key}>
                    {collapse && collapse.filter((item) => item.in_menu && userPermissions.includes(item.key))
                        .map(({ key: collapseKey, route, name: collapseName, icon: collapseIcon }, index) => (
                            <MenuItem
                                key={collapseKey + index}
                                component={Link}
                                to={route}
                                onClick={close}
                                sx={{ pl: 0 }}
                            >
                                <SoftBox minWidth="200px" width="100%" display="flex" alignItems="center" py={0.5}>
                                    <SoftBox display="flex" justifyContent="center" alignItems="center" width="2rem" height="2rem" pr={0.75}>
                                        {typeof collapseIcon === "string" ? <Icon sx={{ fontSize: "20px !important" }}>{collapseIcon}</Icon> : collapseIcon}
                                    </SoftBox>
                                    <SoftTypography variant="button" fontWeight="bold">
                                        {collapseName}
                                    </SoftTypography>
                                </SoftBox>
                            </MenuItem>
                        ))}
                </Fragment>
            ));
        }
    }

    const renderMenuContent = (
        <SoftBox py={1} px={2}>
            <Grid container spacing={3}>
                <Grid item xxs={12} lg={4}>
                    {renderMenuOptionsRoute(route_path)}
                </Grid>
            </Grid>
        </SoftBox>
    );

    return mobileMenu ? renderMenuContent : (
        <BaseNavbarMenu {...{ open, close, openHandler }}>
            {renderMenuContent}
        </BaseNavbarMenu>
    );
}

// Typechecking props for the MenuOptions
MenuOptions.propTypes = {
    routes: PropTypes.arrayOf(PropTypes.object).isRequired,
    route_path: PropTypes.string,
    open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    close: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    openHandler: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    mobileMenu: PropTypes.bool,
    noCollapse: PropTypes.bool
};

export default MenuOptions;